import { Segment, Table, Header } from 'semantic-ui-react';

type PayDownPlanQuotesStatusProps = {
    accountId: string;
    payDownPlanQuotesStatus: PayDownPlanQuotesStatusResponse;
  }

export default function PayDownPlanQuotesStatus(props: PayDownPlanQuotesStatusProps) {
    return (
        <>
            <Segment>
                <Header as="h2">Status</Header>
                <Table celled>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>Selected Quote Id</Table.Cell>
                            <Table.Cell>Status</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>{props.payDownPlanQuotesStatus?.selectedQuoteId}</Table.Cell>
                            <Table.Cell>{props.payDownPlanQuotesStatus?.status}</Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </Segment>
        </>
    )
}